import { render, staticRenderFns } from "./CustomersSummarySection.vue?vue&type=template&id=19315a7c"
import script from "./CustomersSummarySection.vue?vue&type=script&lang=js"
export * from "./CustomersSummarySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports